import React, {useContext, useEffect, useState} from 'react';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {useNavigate} from "react-router-dom";
import {PageContext} from "@lb/mlib-components";

const Page = ({noPadding, padding = 2, marginTop = 10, goBack, children}) => {

    const navigate = useNavigate();
    const [currentURL, setCurrentURL] = useState(window.location.pathname);
    const pageCtx = useContext(PageContext);

    useEffect(() => {
        setCurrentURL(window.location.pathname);
    }, [window.location.pathname]);

    return (
        <Box padding={noPadding ? 0 : padding}
             paddingTop={noPadding ? 8 : marginTop}>
            {goBack && (
                <Button
                    size="large"
                    sx={{paddingLeft: 0}}
                    startIcon={<ChevronLeftIcon size="small" fontSize="80%"/>}
                    onClick={() => navigate(currentURL.replace(/\/[^/]+$/, ''))}
                >
                    {pageCtx.title.split('|')[pageCtx.title.split('|').length - 1]}
                </Button>
            )}
            {children}
        </Box>
    );
}

export default Page;